// @flow

import { observer } from "mobx-react";
import React from "react";

import VideoStore from "app/stores/VideoStore";
import VideoAbout from "app/components/VideoAbout/VideoAbout";
import VideoShareStore from "app/stores/VideoShareStore";

type Props = {};

@observer
export default class VideoAboutContainer extends React.Component<Props> {
    render() {
        if (!VideoStore.video) {
            return null;
        }

        return (
            <VideoAbout
                video={VideoStore.video}
                editable={VideoStore.isEditable}
                onReport={VideoStore.report}
                onShare={VideoShareStore.share}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/VideoAboutContainer.js